/* eslint-disable */
import { inject, Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import {
  HttpClient,
  HttpEvent,
  HttpEventType,
  HttpRequest,
} from "@angular/common/http";
import { Observable, of, Subscription } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { IFileCreateResponse } from "../components/cab-file-input/file.interface";
import {
  IFileInputRemoveFile,
  IFileInputUploadFile,
  IFileInputUploadFileResponse,
} from "../interfaces/file-input.interface";
import { ToastService } from "@core/services/toast.service";

@Injectable({
  providedIn: "root",
})
export class CabFileInputService {
  private unsubscriber = new Subscription();
  private _http = inject(HttpClient);
  private _toastService = inject(ToastService);

  uploadFile(
    options: IFileInputUploadFile,
    bucketName = "act"
  ): Observable<IFileInputUploadFileResponse> {
    const { file } = options;

    const formData = new FormData();
    formData.append("file", file, file.name);

    const req = new HttpRequest("POST", this.getBaseUrl(bucketName), formData, {
      reportProgress: true,
    });

    return this._http.request(req).pipe(
      map((event: HttpEvent<unknown>): IFileInputUploadFileResponse => {
        const res: IFileInputUploadFileResponse = {
          eventType: event.type,
          progress: 0,
          response: null,
        };
        switch (event.type) {
          case HttpEventType.UploadProgress:
            res.progress = Math.round(
              (100 * event.loaded) / Number(event.total)
            );
            break;
          case HttpEventType.Response:
            res.response = event.body as IFileCreateResponse;
            res.progress = 100;
            break;
        }
        return res;
      })
    );
  }

  downloadFile(
    value: string[],
    path = "",
    params = {},
    onSuccess = () => {},
    onError = (error: any) => error
  ) {
    if (value[1] === null || value[1] === "" || value[1] === undefined) return;

    const hasPathAndParams = path && params;
    const generatePath = path + "?" + this.mapQueryParams(params);

    this.unsubscriber.add(
      this._http
        .get(
          hasPathAndParams
            ? generatePath
            : `${environment.apiUrl}file-service/buckets/download?file=${value[1]}`,
          {
            responseType: "blob",
          }
        )
        .subscribe({
          next: (blob) => {
            if (Array.isArray(value)) {
              this.hmlDownload(blob, value[1]);
            } else {
              this.hmlDownload(blob, value);
            }
            onSuccess();
          },
          error: (error) => {
            this._toastService.error("FILE_INPUT.DOWNLOAD_ERROR_MESSAGE");
            onError(error);
          },
        })
    );
  }

  hmlDownload(blob: Blob, fileName: any) {
    const a = document.createElement("a");
    const objectURL = URL.createObjectURL(blob);
    // hozircha fileId bilan download qilish
    fileName = fileName.split("/");

    a.href = objectURL;
    a.download = fileName[fileName?.length - 1] || "file";
    a.click();
    URL.revokeObjectURL(objectURL);
  }

  removeFile(options: IFileInputRemoveFile) {
    const { fileId } = options;
    return this._http.delete(this.getBaseUrl(fileId));
  }

  getBaseUrl(bucketName = "test"): string {
    return `${environment.apiUrl}file-service/buckets/upload?folderType=${bucketName}`;
  }

  mapQueryParams(params: any) {
    let convertToQueryPath = "";
    for (const property in params) {
      if (Object.keys(params)) {
        convertToQueryPath += `${property}=${params[property]}&`;
      }
    }

    return convertToQueryPath;
  }

  loadImage(fileId: any) {
    return this._http
      .get(
        `${environment.apiUrl}file-service/buckets/download?file=${fileId}`,
        {
          responseType: "blob",
        }
      )
      .pipe(
        catchError((err) => {
          this._toastService.error("FILE_INPUT.DOWNLOAD_ERROR_MESSAGE");
          return of(err);
        })
      );
  }

  unsubscribeRequest() {
    this.unsubscriber.unsubscribe();
  }
}
